<template>
  <Layout>
    <div class="mc-alert-center-detail__wrapper">
      <PageHeader
        v-if="!loading"
        :title="title"
        :sub-title="subTitle"
        :customTitle="hasRuleNameScope"
      >
        <template #beforeTitle>
          <div class="d-flex align-items-center">
            <i
              v-b-tooltip.hover="
                `${$t('notification.text.sourceDevice')}: ${
                  alert.sourceDeviceType === 'CAM' ? $t('trackVideo.camera') : 'GPS'
                }`
              "
              :class="{
                'mc-fa mc-icon-sensor icon-outline_video me-2': alert.sourceDeviceType === 'CAM',
                'mc-fa mc-icon-sensor icon-outline_device me-2': alert.sourceDeviceType === 'GPS',
              }"
            />
          </div>
        </template>

        <template #title>
          <div v-if="hasRuleNameScope" class="mc-custom-page-title">
            <h4 class="mc-page-title">
              {{
                alert.alertRule
                  ? alert.alertRule.label
                  : language == 'en'
                  ? alert?.alert?.descriptionEng
                  : alert?.alert?.descriptionIdn
              }}
            </h4>
            <p class="">
              {{ language == 'en' ? alert?.alert?.descriptionEng : alert?.alert?.descriptionIdn }}
            </p>
          </div>
        </template>
        <template #afterTitle>
          <div>
            <McButtonBack />

            <b-dropdown class="ms-2 notification-more-action-wrapper">
              <template #button-content>
                {{ $t('global.action.moreAction') }}
                <i class="mc-fa icon-outline_arrow-ios-down" />
              </template>
              <b-dropdown-item @click="openLiveview(alert)">
                <i class="mc-fa icon-outline_live-view" />
                {{ $t('tower.trackVehicles') }}
              </b-dropdown-item>
              <template v-if="voipState.isHave">
                <template v-if="vehicleIdsCallActive.includes(Number(voipState.vehicleIdVoip))">
                  <b-dropdown-item class="notification__end-call" @click="clickEndCall()">
                    <i class="mc-fa icon-outline_phone-off" />
                    {{ $t('trackVideo.endCall') }}
                  </b-dropdown-item>
                </template>
                <template v-else>
                  <b-dropdown-item
                    v-if="
                      hasAccessAll([
                        'b3f-two-way-communication:read',
                        'b3f-two-way-communication-all-module:read',
                      ]) &&
                      (voipState.deviceType === 'bsj' || voipState.deviceType === 'vss-howen')
                    "
                    :disabled="
                      (vehicleIdsCallActive.length >= $store.state.voip.maxCall &&
                        !vehicleIdsCallActive.includes(Number(voipState.vehicleIdVoip))) ||
                      $store.state.voip.isBroadcastActive
                    "
                    @click="clickCall()"
                  >
                    <i class="mc-fa icon-outline_phone" />
                    {{ $t('notification.action.callDriver') }}
                  </b-dropdown-item>
                </template>
              </template>

              <!-- TODO : Handle this with squad C -->
              <!-- <b-dropdown-item @click="openSettingNotification()">
                <i class="mc-fa icon-outline_settings" />
                {{ $t('notification.object.notificationSetting') }}
              </b-dropdown-item> -->
            </b-dropdown>
          </div>
        </template>
      </PageHeader>
      <b-row class="mc-alert-center-detail__wrapper-row">
        <b-col md="6" class="mc-alert-center-detail__wrapper-col">
          <AlertDetail v-if="!loading" :alertData="alert" @selectAlert="selectAlert" />
        </b-col>
        <b-col md="6" class="mc-alert-center-detail__wrapper-col">
          <MapHistory v-if="!loading" :detailData="alert" :selectedAlert="selectedAlert" />
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import AlertDetail from './AlertDetail.vue'
import MapHistory from './MapHistory.vue'
import { GET_RAW_ALERT } from '@/services/api/fleet'
import PageHeader from '@/components/page-header-v2'
import { Helper } from '@/mixin/helper'
import McButtonBack from '@/components/McButtonBack'
import i18n from '@/i18n'
import { mapGetters } from 'vuex'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  page: {
    title: 'Detail Notifikasi',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    AlertDetail,
    MapHistory,
    PageHeader,
    McButtonBack,
  },

  mixins: [Helper, MixPanel],

  data() {
    return {
      loading: true,
      alert: {},
      language: i18n.locale,
      selectedAlert: {
        alert: {},
        timeIndex: 0,
      },
      voipState: {
        isHave: false,
        deviceType: null,
        vehicleIdVoip: null,
        imeiVoip: null,
      },
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),

    ...mapGetters('voip', ['vehicleIdsCallActive']),
    title() {
      return this.language == 'en'
        ? this.alert?.alert?.descriptionEng
        : this.alert?.alert?.descriptionIdn
    },
    subTitle() {
      return `${this.momentDateShortMonth(this.alert.createdOn)} - ${this.momentTimeSeconds(
        this.alert.createdOn
      )} ${this.getLabelTimezone()}`
    },
    isSalesDemo() {
      const email = this.$store.state.identity.whoami.email
      const demoStaging =
        email === 'mceasy-demo@vsms.co.id' &&
        (window.location.host === 'vsms2-staging.mceasy.cloud' ||
          window.location.host === 'localhost:3000')
      return (
        (demoStaging || window.location.host === 'demo.mceasy.com') &&
        this.$route.query.isDemo === JSON.stringify(true)
      )
    },

    hasRuleNameScope() {
      return this.hasAccess('e4J-alert-rule-name-as-title:read')
    },
  },

  watch: {
    '$i18n.locale': function (val) {
      this.language = val
    },
  },

  created() {
    this.$root.$on('notification-detail-reload', this.reloadData)
  },

  async mounted() {
    await this.reloadData()
    this.setVoipState()
  },

  beforeDestroy() {
    this.$root.$off('notification-detail-reload', this.reloadData)
  },

  methods: {
    async reloadData() {
      if (this.isSalesDemo) {
        this.alert = JSON.parse(localStorage.getItem('data-demo-detail'))
        this.loading = false
        this.$store.commit('notification/setDetailNotification', this.alert)
        this.$store.commit(
          'notification/setListNotificationMedia',
          this.alert.media.map((media) => ({
            ...media,
            url:
              process.env.VUE_APP_DEMO_ASSET_URL +
              '/' +
              this.alert.vehicleId +
              '/' +
              media.mediaFilename,
          }))
        )

        return
      }
      const paramId = this.$route.params.id
      let filter = {}

      this.loading = true

      if (!paramId.includes('-')) {
        filter = {
          rawAlertId: paramId,
        }
      } else {
        const details = paramId.split('-')
        filter = {
          alertCode: Number(details[0]),
          vehicleId: Number(details[1]),
          createdOn: new Date(Number(details[2])).toISOString(),
          alertFlag:
            details[3] === 'false' ? false : details[3] === 'null' ? null : Boolean(details[3]),
        }
      }
      const res = await this.$apollo.query({
        query: GET_RAW_ALERT,
        variables: {
          filter,
        },
        fetchPolicy: 'no-cache',
      })
      if (!res.data.rawAlert.isSuccessful) {
        this.$mcToast.error(res.data.rawAlert.message)
      }
      this.alert = res.data.rawAlert.rawAlert
      const dvhData = res.data.rawAlert.rawAlert.media
      this.$store.commit('notification/setDetailNotification', res.data.rawAlert.rawAlert)
      this.$store.commit('notification/setListNotificationMedia', dvhData)
      this.track('Open Notification Details Page', {
        'alert-type': this.alert?.alert?.descriptionIdn,
      })
      this.loading = false
    },

    selectAlert(alert, timeIndex) {
      this.selectedAlert = { alert, timeIndex }
    },

    openLiveview(alert) {
      const url = `${window.location.protocol}//${window.location.host}/liveview-2/?type=vehicle&vehicleId=${alert.vehicleId}`
      window.location.href = url
    },

    clickEndCall() {
      this.track('Detail Notification - VoIP End Call', {
        entryPoint: 'Detail Notification',
      })
      this.$store.dispatch('voip/endCall', { vehicleId: Number(this.voipState.vehicleIdVoip) })
    },

    clickCall() {
      const deviceType = this.voipState.deviceType
      if (
        this.hasAccessAll([
          'b3f-two-way-communication:read',
          'b3f-two-way-communication-all-module:read',
        ])
      ) {
        this.track('Detail Notification - VoIP Admin make a call', {
          entryPoint: 'Detail Notification',
          alertCode: this.alert.alert.alertCode,
          alertDescription: this.alert.alert.descriptionIdn,
        })
        this.$store.dispatch('voip/startNewCall', {
          dataNewCall: {
            vehicleId: this.voipState.vehicleIdVoip,
            licensePlate: this.alert.vehicle.licensePlate,
            driver: this.alert.driver?.fullname ?? null,
            imei: this.voipState.imeiVoip,
            deviceType,
            entryPoint: 'detailNotification',
          },
        })
      }
    },

    openSettingNotification() {
      this.$router.push({
        name: 'Setting Notification List',
      })
    },

    async setVoipState() {
      const isHaveChildren = this.alert.vehicle?.children?.length > 0
      let deviceType = this.getDeviceType(this.alert.vehicle?.device?.deviceCode)
      let imeiVoip = this.alert.vehicle?.imei
      let vehicleIdVoip = this.alert.vehicleId
      if (isHaveChildren) {
        deviceType = this.getDeviceType(this.alert.vehicle?.children?.[0]?.device?.deviceCode)
        imeiVoip = this.alert.vehicle?.children?.[0]?.imei
        vehicleIdVoip = this.alert.vehicle?.children?.[0]?.id
      }
      this.voipState.isHave = deviceType === 'bsj' || deviceType === 'vss-howen'
      await this.$nextTick()
      if (this.voipState.isHave) {
        this.voipState.deviceType = deviceType
        this.voipState.imeiVoip = imeiVoip
        this.voipState.vehicleIdVoip = vehicleIdVoip
      }
    },
  },
}
</script>

<style lang="scss">
.mc-alert-center-detail__wrapper {
  .banner-header {
    padding: 12px 0px !important;
  }

  .mc-icon-sensor {
    padding: 10px;
    border-radius: 100%;
    background-color: $teal-100;
    font-size: 21px;
    margin-top: -10px;
  }
}

.notification-more-action-wrapper {
  .btn.dropdown-toggle {
    background-color: $white;
    border: 1px solid $mep-primary;
    color: $mep-primary;
    &:focus {
      color: $mep-primary;
      background-color: $white;
      border: 1px solid $mep-primary;
      opacity: 1;
    }
    &:hover {
      background-color: $mep-primary;
      border: 1px solid $mep-primary;
      color: $white;
      opacity: 1;
      i::before {
        color: $white;
      }
    }
  }
  .notification__end-call {
    .dropdown-item {
      color: $red;
      i::before {
        color: $red;
      }
    }
  }
}

.mc-alert-center-detail__wrapper-col {
  height: 100%;
}

@media only screen and (max-width: 1080px) {
  .mc-alert-center-detail__wrapper-row {
    flex-direction: column-reverse;

    > .col-md-6 {
      width: 100%;
    }
  }
}
</style>
